
<template>
	<div class="dashboard-movimientos-container">
		<template v-if="loader==true">
			<ProgressBar mode="indeterminate" style="height: .5em; margin-bottom: 1rem;" />
		</template>

		<div class="col-12 flex flex-column header-landing-seway">
			<div class="flex grid">
				<div class="col-12 md:col-6 lg:col-2">
					<div class="indicator-card-modern total" @click="selectindicador(10)">
						<div class="indicator-badge-modern">Ver todos</div>
						<div class="indicator-icon-modern">
							📊
						</div>
						<div class="indicator-title-modern">Total</div>
						<div class="indicator-value-modern">{{indicadores_viajes.total_deliveries}}</div>
					</div>
				</div>

				

				<div class="col-12 md:col-6 lg:col-2">
					<div class="indicator-card-modern pendientes" @click="selectindicador(1)">
						<div class="indicator-badge-modern">Filtrar</div>
						<div class="indicator-icon-modern">
							⏳
						</div>
						<div class="indicator-title-modern">Pendientes</div>
						<div class="indicator-value-modern">{{indicadores_viajes.total_pendiente}}</div>
					</div>
				</div>

				<div class="col-12 md:col-6 lg:col-2">
					<div class="indicator-card-modern aceptados" @click="selectindicador(2)">
						<div class="indicator-badge-modern">Filtrar</div>
						<div class="indicator-icon-modern">
							✅
						</div>
						<div class="indicator-title-modern">Aceptados</div>
						<div class="indicator-value-modern">{{indicadores_viajes.total_aceptado}}</div>
					</div>
				</div>

				<div class="col-12 md:col-6 lg:col-2">
					<div class="indicator-card-modern transito" @click="selectindicador(3)">
						<div class="indicator-badge-modern">Filtrar</div>
						<div class="indicator-icon-modern">
							🚚
						</div>
						<div class="indicator-title-modern">En Tránsito</div>
						<div class="indicator-value-modern">{{indicadores_viajes.total_transito}}</div>
					</div>
				</div>

				<div class="col-12 md:col-6 lg:col-2">
					<div class="indicator-card-modern finalizado" @click="selectindicador(4)">
						<div class="indicator-badge-modern">Filtrar</div>
						<div class="indicator-icon-modern">
							🎯
						</div>
						<div class="indicator-title-modern">Finalizado</div>
						<div class="indicator-value-modern">{{indicadores_viajes.total_finalizado}}</div>
					</div>
				</div>

				<div class="col-12 md:col-6 lg:col-2">
					<div class="indicator-card-modern rechazados" @click="selectindicador(6)">
						<div class="indicator-badge-modern">Filtrar</div>
						<div class="indicator-icon-modern">
							❌
						</div>
						<div class="indicator-title-modern">Rechazados</div>
						<div class="indicator-value-modern">{{indicadores_viajes.total_rechazados}}</div>
					</div>
				</div>
			</div>
		</div>

		<template v-if="estado_viaje == 0">
			<!-- Header -->
			<div class="dashboard-header-movimientos">
				<h1>🚛 Panel de Control de Viajes</h1>
				<p>Gestione y analice el estado de todos los viajes SEWAY Plus</p>
			</div>

		</template>
		<template v-else>
			<!-- <div class="viajes-container-modern">
				<div class="viajes-header-modern">
					<div class="header-content">
						<div class="header-left">
							<Button 
								icon="pi pi-arrow-left" 
								label="Volver" 
								class="p-button-text p-button-lg"
								@click="estado_viaje = 0"
							/>
							<div class="header-title">
								<h2>{{ estado_viaje_descripcion }}</h2>
								<span class="total-badge">{{ pagination.total }} viajes</span>
							</div>
						</div>
						<div class="header-actions">
							<Button 
								label="Crear Viaje" 
								icon="pi pi-plus" 
								class="p-button-success"
								@click="openModalNuevoViaje"
							/>
							<Button 
								icon="pi pi-filter" 
								label="Filtros"
								class="p-button-outlined"
								@click="toggle"
							/>
						</div>
					</div>
				</div>

				<OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" :style="{width: '600px'}">
					<div class="filters-panel">
						<h3 class="filters-title">
							<i class="pi pi-filter mr-2"></i>
							Filtros de Búsqueda
						</h3>
						<div class="grid p-fluid">
							<div class="col-12 md:col-6">
								<span class="p-float-label">
									<InputMask mask="aaa-999" id="placa" v-model="frmfiltros.placa" />
									<label for="placa">Placa</label>
								</span>
							</div>
							<div class="col-12 md:col-6">
								<span class="p-float-label">
									<InputText v-model="frmfiltros.conductor_documento" id="doc_conductor" type="number" />
									<label for="doc_conductor">Número Movimiento</label>
								</span>
							</div>
							<div class="col-12 md:col-6">
								<span class="p-float-label">
									<Calendar 
										v-model="frmfiltros.fechasolicitud" 
										:showTime="false" 
										:showButtonBar="true" 
										:showIcon="true"
										placeholder="Fecha inicial"
									/>
								</span>
							</div>
							<div class="col-12 md:col-6">
								<span class="p-float-label">
									<Calendar
										v-model="frmfiltros.fechasolicitudrango"
										:minDate="validMinDate"
										:showButtonBar="true"
										:showTime="false"
										:showIcon="true"
										placeholder="Fecha final"
									/>
								</span>
							</div>
							<div class="col-12 md:col-6">
								<Button 
									label="Buscar" 
									icon="pi pi-search" 
									class="p-button-primary"
									@click="cargar_detalle(1)" 
								/>
							</div>
							<div class="col-12 md:col-6">
								<Button 
									label="Limpiar" 
									icon="pi pi-filter-slash" 
									class="p-button-outlined"
									@click="limpiar" 
								/>
							</div>
						</div>
					</div>
				</OverlayPanel>

				<div class="viajes-table-modern">
					<div v-for="viaje in deliveries" :key="viaje.id_viaje" class="viaje-card-modern">
						<div class="viaje-header" @click="toggleViaje(viaje)">
							<div class="viaje-info-grid">
								<div class="info-block">
									<div class="info-icon blue">
										<i class="pi pi-hashtag"></i>
									</div>
									<div class="info-content">
										<span class="info-label">Movimiento</span>
										<strong class="info-value">{{ viaje.movimiento_numero }}</strong>
									</div>
								</div>
								<div class="info-block">
									<div class="info-icon green">
										<i class="pi pi-truck"></i>
									</div>
									<div class="info-content">
										<span class="info-label">Placa</span>
										<strong class="info-value">{{ viaje.placa }}</strong>
									</div>
								</div>
								<div class="info-block">
									<div class="info-icon orange">
										<i class="pi pi-user"></i>
									</div>
									<div class="info-content">
										<span class="info-label">Conductor</span>
										<strong class="info-value">{{ viaje.conductor_nombre }}</strong>
										<span class="info-sublabel">CC: {{ viaje.conductor_documento }}</span>
									</div>
								</div>
								<div class="info-block">
									<div class="info-icon purple">
										<i class="pi pi-building"></i>
									</div>
									<div class="info-content">
										<span class="info-label">Sucursal</span>
										<strong class="info-value">{{ viaje.sucorigina_nombre }}</strong>
										<span class="info-sublabel">{{ viaje.movimiento_operacion }}</span>
									</div>
								</div>
								<div class="info-block">
									<div class="info-icon pink">
										<i class="pi pi-calendar"></i>
									</div>
									<div class="info-content">
										<span class="info-label">Fecha Creación</span>
										<strong class="info-value">{{ formatDate(viaje.fecha_creacion) }}</strong>
										<span class="info-sublabel">{{ viaje.movimiento_fecha }}</span>
									</div>
								</div>
								<div class="info-block">
									<div class="info-icon teal">
										<i class="pi pi-box"></i>
									</div>
									<div class="info-content">
										<span class="info-label">Entregas</span>
										<div class="entregas-stats">
											<Tag severity="warning" :value="`${viaje.total_pendiente} Pend.`" />
											<Tag severity="success" :value="`${viaje.total_entregado} Fin.`" />
										</div>
										<Tag class="mt-1" :severity="getEstadoSeverity(viaje.estado_nombre)" :value="viaje.estado_nombre" />
									</div>
								</div>
							</div>
							<div class="expand-button">
								<i :class="isViajeExpanded(viaje) ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
							</div>
						</div>
						<transition name="expand">
							<div v-if="isViajeExpanded(viaje)" class="viaje-content">
								<TabViewMovimiento
										:variableProp="viaje.id_movimiento_systram"
										:id_deliverie="viaje.id_deliverie"
										:id_viaje="viaje.id_viaje"
										:num_movimiento="viaje.movimiento_numero" 
										:IdCustomer="viaje.id_customer" 
										:Placa="viaje.placa" 
										:conductor_documento="viaje.conductor_documento" 
									/>
							</div>
						</transition>
					</div>
					<div v-if="deliveries.length === 0 && !loader" class="empty-state">
						<i class="pi pi-inbox empty-icon"></i>
						<h3>No hay viajes para mostrar</h3>
						<p>Intenta ajustar los filtros de búsqueda</p>
					</div>
				</div>
				<div class="pagination-modern" v-if="deliveries.length > 0">
					<div class="pagination-info">
						Mostrando {{ pagination.from }} - {{ pagination.to }} de {{ pagination.total }} resultados
					</div>
					<Paginator 
						:first="pagination.from - 1" 
						:rows="pagination.per_page" 
						:totalRecords="pagination.total"
						@page="onChangePage($event)"
					/>
				</div>
			</div> -->
			<div class="col-12 lg:col-12">
				<Toolbar class="mb-1">
					<template v-slot:start>
						<Button icon="pi pi-arrow-circle-left" class="p-button-rounded p-button-primary p-button-outlined mx-2 mt-2" :loading="loader" title="Volver" label="Volver" @click="estado_viaje = 0" />
						<div class="mt-3 ml-5 flex align-items-center">
							<h3>{{estado_viaje_descripcion ?? ''}}</h3>
						</div>
					</template>
					<template v-slot:end>
						<Button 
							label="Crear Viaje" 
							icon="pi pi-plus-circle" 
							class="p-button-raised button-sewayblue mr-2" 
							@click="openModalNuevoViaje" 
							 :loading="loader"
						/>
						<Button type="button" label="Filtrar" icon="pi pi-filter-fill"
						 :loading="loader" @click="toggle" class="p-button-raised button-sewayblue"/>
					</template>
				</Toolbar>
			</div>
			<OverlayPanel ref="op" appendTo="body" :showCloseIcon="true"  :style="{width: '600px'}">
				<div class="grid p-fluid">
					<div class="col-12 lg:col-6">
						<span class="p-float-label">
							<InputMask mask="aaa-999" id="placa" v-model="frmfiltros.placa" />
							<label for="placa">Placa</label>
						</span>
					</div>
					<div class="col-12 lg:col-6">
						<span class="p-float-label">
							<InputText v-model="frmfiltros.conductor_documento" id="doc_conductor" type="number" placeholder="" />
							<label for="doc_conductor">Referencia Externa</label>
						</span>
					</div>
					<div class="col-12 lg:col-6">
						<span class="p-float-label">
							<Calendar v-model="frmfiltros.fechasolicitud" :showTime="false" :showButtonBar="true" :showIcon="true" :locale="$primevue.config.locale" placeholder="Seleccione fecha"/>
						</span>
					</div>
					<div class="col-12 lg:col-6">
						<span class="p-float-label">
							<Calendar
								v-model="frmfiltros.fechasolicitudrango"
								:minDate="validMinDate"
								:showButtonBar="true"
								:showTime="false"
								:showIcon="true"
								:locale="$primevue.config.locale"
								placeholder="Seleccione fecha final"
							/>
						</span>
					</div>

					<div class="col-12 lg:col-6">
						<Button type="button" class="p-button-raised button-sewayblue mb-1" label="Buscar" icon="pi pi-search" :loading="loader" @click="cargar_detalle(1)" />
					</div>
					<div class="col-12 lg:col-6">
						<Button type="button" class="p-button-raised button-sewayblue" label="Limpiar" icon="pi pi-filter-slash" :loading="loader" @click="limpiar" />
					</div>
				</div>
			</OverlayPanel>
			<div class="p-fluid grid">
			
				<div class="col-12 lg:col-12">
					<DataTable :value="deliveries" :expandedRows="expandedRows" @rowClick="onRowClick"  sortMode="multiple" class="tabla-viajes" tableStyle="width: 100%;">
							<Column expander style="width: 5rem" />
							<Column field="movimiento_numero" header="Nro Movimiento" sortable>
								<template #body="slotProps">
									<div  class="cursor-pointer">
										<strong>{{slotProps.data.movimiento_numero}}</strong>
									</div>
								</template>
							</Column>
							<Column field="sucorigina_nombre" header="Sucursal" sortable>
								<template #body="slotProps">
									<div  class="cursor-pointer">
										{{slotProps.data.sucorigina_nombre}}
									</div>
								</template>
							</Column>
							<Column field="movimiento_operacion" header="Tipo Operación" sortable>
								<template #body="slotProps">
									<div  class="cursor-pointer">
										{{slotProps.data.movimiento_operacion}}
									</div>
								</template>
							</Column>
							<Column field="placa" header="Placa" sortable>
								<template #body="slotProps">
									<div  class="cursor-pointer">
									<strong>{{slotProps.data.placa}}</strong>
									</div>
								</template>
							</Column>
							<Column field="conductor_nombre" header="Conductor" sortable>
								<template #body="slotProps">
									<div  class="cursor-pointer">
									{{slotProps.data.conductor_nombre}}<br>
									CC: {{slotProps.data.conductor_documento}}
									</div>
								</template>
							</Column>
							<Column field="fecha_creacion" header="Fecha Creación" sortable>
								<template #body="slotProps">
									<div  class="cursor-pointer">
									{{new Date(slotProps.data.fecha_creacion).toLocaleDateString('es-CO')}}<br>
									{{slotProps.data.estado_nombre}}
									</div>
								</template>
							</Column>
							<Column field="movimiento_fecha" header="Fecha Movimiento" sortable>
								<template #body="slotProps">
									<div  class="cursor-pointer">
									{{slotProps.data.movimiento_fecha}}
									</div>
								</template>
							</Column>
							<Column field="total_detalle" header="Total Entregas" sortable>
								<template #body="slotProps">
									<div  class="cursor-pointer mx-4">
									<h3>{{slotProps.data.total_detalle}}</h3>
									</div>
								</template>
							</Column>
							<Column field="total_entregado" header="Estados Entregas" sortable>
								<template #body="slotProps">
									<div  class="cursor-pointer">
									<strong>Pendientes: </strong>{{slotProps.data.total_pendiente}}<br>
									<strong>Finalizadas: </strong>{{slotProps.data.total_entregado}}
									</div>
								</template>
							</Column>
							<!-- <Column field="total_entregado" >
								<template #body="slotProps">
									<div class="viajes-table-modern">
										<div class="viaje-card-modern">
											<div class="viaje-header">
												<div class="viaje-info-grid">
													<div class="info-block">
														<div class="info-icon blue">
															<i class="pi pi-hashtag"></i>
														</div>
														<div class="info-content">
															<span class="info-label">Movimiento</span>
															<strong class="info-value">{{ slotProps.data.movimiento_numero }}</strong>
														</div>
													</div>
													<div class="info-block">
														<div class="info-icon green">
															<i class="pi pi-truck"></i>
														</div>
														<div class="info-content">
															<span class="info-label">Placa</span>
															<strong class="info-value">{{ slotProps.data.placa }}</strong>
														</div>
													</div>
													<div class="info-block">
														<div class="info-icon orange">
															<i class="pi pi-user"></i>
														</div>
														<div class="info-content">
															<span class="info-label">Conductor</span>
															<strong class="info-value">{{ slotProps.data.conductor_nombre }}</strong>
															<span class="info-sublabel">CC: {{ slotProps.data.conductor_documento }}</span>
														</div>
													</div>
													<div class="info-block">
														<div class="info-icon purple">
															<i class="pi pi-building"></i>
														</div>
														<div class="info-content">
															<span class="info-label">Sucursal</span>
															<strong class="info-value">{{ slotProps.data.sucorigina_nombre }}</strong>
															<span class="info-sublabel">{{ slotProps.data.movimiento_operacion }}</span>
														</div>
													</div>
													<div class="info-block">
														<div class="info-icon pink">
															<i class="pi pi-calendar"></i>
														</div>
														<div class="info-content">
															<span class="info-label">Fecha Creación</span>
															<strong class="info-value">{{ formatDate(slotProps.data.fecha_creacion) }}</strong>
															<span class="info-sublabel">{{ slotProps.data.movimiento_fecha }}</span>
														</div>
													</div>
													<div class="info-block">
														<div class="info-icon teal">
															<i class="pi pi-box"></i>
														</div>
														<div class="info-content">
															<span class="info-label">Entregas</span>
															<div class="entregas-stats">
																<Tag severity="warning" :value="`${slotProps.data.total_pendiente} Pend.`" />
																<Tag severity="success" :value="`${slotProps.data.total_entregado} Fin.`" />
															</div>
															<Tag class="mt-1" :severity="getEstadoSeverity(slotProps.data.estado_nombre)" :value="slotProps.data.estado_nombre" />
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
							</Column> -->
							<template #expansion="slotProps">
								<div class="col-12">
									<TabViewMovimiento :variableProp="slotProps.data.id_movimiento_systram" :id_deliverie="slotProps.data.id_deliverie" :id_viaje="slotProps.data.id_viaje" :num_movimiento="slotProps.data.movimiento_numero" :IdCustomer="slotProps.data.id_customer" :Placa="slotProps.data.placa" :conductor_documento="slotProps.data.conductor_documento" />
								</div>
							</template>
						</DataTable>
					

					<div>
						<Paginator :v-model:first="pagination.from" :rows="pagination.per_page" :rowsPerPageOptions="[15]" :totalRecords="pagination.total" @page="onChangePage($event)"></Paginator>
					</div>
					
				</div>
			</div>
		</template>	
		<Dialog 
			v-model:visible="modal_crear_viaje" 
			:style="{width: '95vw', maxWidth: '1000px'}" 
			:header="titulo_modal" 
			:modal="true" 
			class="p-fluid modal-crear-viaje"
		>
			<TabView>
				<!-- TAB 1: FORMULARIO MANUAL -->
				<TabPanel>
					<template #header>
						<span class="flex align-items-center gap-2">
							<i class="pi pi-file mr-1"></i>
							<span class="font-semibold">Formulario Manual</span>
						</span>
					</template>
					
					<div class="grid p-fluid">
						<!-- Información General del Viaje -->
						<div class="col-12">
							<div class="section-header">
								<i class="pi pi-truck mr-2"></i>
								<span class="section-title">Información General del Viaje</span>
							</div>
						</div>

						<div class="col-12 lg:col-12">
							<span class="p-float-label">
								<InputText 
									id="email" 
									v-model="frmUsuario.email" 
									type="email"
									:class="{'p-invalid': submitted && !frmUsuario.email}"
								/>
								<label for="email">Email*</label>
							</span>
							<small class="p-error" v-if="submitted && !frmUsuario.email">El email es requerido</small>
						</div>

						<div class="col-12 lg:col-6">
							<span class="p-float-label">
								<InputMask mask="aaa-999" id="placa" v-model="frmUsuario.placa" :class="{'p-invalid': submitted && !frmUsuario.placa}" />
								<label for="placa">Placa*</label>
							</span>
							<small class="p-error" v-if="submitted && !frmUsuario.placa">La placa es requerida</small>
						</div>

						<div class="col-12 lg:col-6">
							<span class="p-float-label">
								<Dropdown 
									v-model="frmUsuario.tipo_despacho" 
									:options="tipos_despachos" 
									optionLabel="description" 
									optionValue="code_type_dispatch"
									:class="{'p-invalid': submitted && !frmUsuario.tipo_despacho}"
								/>
								<label for="tipo_despacho">Tipo de Despacho*</label>
							</span>
							<small class="p-error" v-if="submitted && !frmUsuario.tipo_despacho">Seleccione un tipo</small>
						</div>

						<div class="col-12 lg:col-6">
							<span class="p-float-label">
								<InputText 
									id="reference_document" 
									v-model="frmUsuario.reference_document" 
									:class="{'p-invalid': submitted && !frmUsuario.reference_document}"
									type="number"
								/>
								<label for="reference_document">Documento Referencia*</label>
							</span>
							<small class="p-error" v-if="submitted && !frmUsuario.reference_document">El documento es requerido</small>
						</div>

						<div class="col-12 lg:col-6">
							<span class="p-float-label">
								<InputNumber 
									:class="{'p-invalid': submitted && !frmUsuario.valor_viaje}"
									v-model="frmUsuario.valor_viaje"
									inputId="valor_viaje"
									mode="currency"
									currency="COP"
									locale="es-CO"
								/>
								<label for="valor_viaje">Costo Total del Viaje*</label>
							</span>
							<small class="p-error" v-if="submitted && !frmUsuario.valor_viaje">El valor del viaje es requerido</small>
						</div>

						<!-- Representante y Propietario -->
						<div class="col-12">
							<div class="section-header">
								<i class="pi pi-users mr-2"></i>
								<span class="section-title">Representante y Propietario</span>
							</div>
						</div>

						<div class="col-12 lg:col-6">
							<span class="p-float-label">
								<InputText 
									id="representative_id" 
									v-model="frmUsuario.representative_id" 
									:class="{'p-invalid': submitted && !frmUsuario.representative_id}"
									type="number"
								/>
								<label for="representative_id">Documento del Representante*</label>
							</span>
							<small class="p-error" v-if="submitted && !frmUsuario.representative_id">El documento del representante es requerido</small>
						</div>

						<div class="col-12 lg:col-6">
							<span class="p-float-label">
								<InputText 
									id="representative" 
									v-model="frmUsuario.representative" 
									:class="{'p-invalid': submitted && !frmUsuario.representative}"
								/>
								<label for="representative">Nombre del Representante*</label>
							</span>
							<small class="p-error" v-if="submitted && !frmUsuario.representative">El nombre del representante es requerido</small>
						</div>

						<div class="col-12 lg:col-6">
							<span class="p-float-label">
								<InputText 
									id="owner_id" 
									v-model="frmUsuario.owner_id" 
									:class="{'p-invalid': submitted && !frmUsuario.owner_id}"
									type="number"
								/>
								<label for="owner_id">Documento del Propietario*</label>
							</span>
							<small class="p-error" v-if="submitted && !frmUsuario.owner_id">El documento del propietario es requerido</small>
						</div>

						<div class="col-12 lg:col-6">
							<span class="p-float-label">
								<InputText 
									id="owner" 
									v-model="frmUsuario.owner" 
									:class="{'p-invalid': submitted && !frmUsuario.owner}"
								/>
								<label for="owner">Nombre del Propietario*</label>
							</span>
							<small class="p-error" v-if="submitted && !frmUsuario.owner">El nombre del propietario es requerido</small>
						</div>

						

						<!-- Configuración del Viaje -->
						<div class="col-12">
							<div class="section-header">
								<i class="pi pi-cog mr-2"></i>
								<span class="section-title">Configuración del Viaje</span>
							</div>
						</div>

						<div class="col-12 lg:col-6">
							<span class="p-float-label">
								<InputText 
									id="hours_validation" 
									v-model="frmUsuario.hours_validation" 
									:class="{'p-invalid': submitted && !frmUsuario.hours_validation}"
									type="number"
								/>
								<label for="hours_validation">Vigencia PreOperacional (Horas)*</label>
							</span>
							<small class="p-error" v-if="submitted && !frmUsuario.hours_validation">Las horas del preoperacional son requeridas</small>
						</div>

						<div class="col-12 lg:col-3">
							<div class="flex flex-column align-items-center">
								<label for="required_firm" class="mb-2 font-semibold">Requiere Firma*</label>
								<Checkbox v-model="frmUsuario.required_firm" :trueValue="1" :falseValue="0" :binary="true" />
							</div>
						</div>

						<div class="col-12 lg:col-3">
							<div class="flex flex-column align-items-center">
								<label for="required_check" class="mb-2 font-semibold">Requiere PreOperacional*</label>
								<Checkbox v-model="frmUsuario.required_check" :trueValue="1" :falseValue="0" :binary="true" />
							</div>
						</div>

						<!-- Detalles de Entrega -->
						<div class="col-12 mt-4">
							<div class="section-header-detalles">
								<div class="flex align-items-center">
									<i class="pi pi-box mr-2"></i>
									<span class="section-title">Detalles de Entrega</span>
								</div>
								<Button 
									label="Agregar Detalle" 
									icon="pi pi-plus" 
									class="p-button-success p-button-sm"
									@click="agregarDetalle"
								/>
							</div>
						</div>

						<div class="col-12">
							<Message severity="info" :closable="false">
								<i class="pi pi-info-circle mr-2"></i>
								Los campos con origen/destino usan la maestra DIVIPOLA
							</Message>
						</div>

						<!-- Acordeón de Detalles -->
						<div class="col-12" v-if="detalles_viaje.length > 0">
							<Accordion :multiple="true" :activeIndex="activeAccordions">
								<AccordionTab v-for="(detalle, index) in detalles_viaje" :key="index">
									<template #header>
										<div class="accordion-header-custom">
											<span class="badge-detalle">Detalle #{{index + 1}}</span>
											<span class="text-sm">Secuencia: {{index + 1}} (auto-incremental)</span>
											<Button 
												icon="pi pi-trash" 
												class="p-button-rounded p-button-danger p-button-text p-button-sm ml-auto"
												@click.stop="eliminarDetalle(index)"
											/>
										</div>
									</template>

									<div class="grid p-fluid detalle-form">
										<!-- Origen y Destino -->
										<div class="col-12">
											<div class="subsection-header">
												<i class="pi pi-map-marker mr-2"></i>
												<span>Origen y Destino (DIVIPOLA)</span>
											</div>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													v-model="detalle.ciudad_origen" 
													:class="{'p-invalid': detalle.submitted && !detalle.ciudad_origen}"
												/>
												<label>Ciudad Origen*</label>
											</span>
											<small class="p-error" v-if="detalle.submitted && !detalle.ciudad_origen">Campo requerido</small>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													v-model="detalle.departamento_origen" 
													:class="{'p-invalid': detalle.submitted && !detalle.departamento_origen}"
												/>
												<label>Departamento Origen*</label>
											</span>
											<small class="p-error" v-if="detalle.submitted && !detalle.departamento_origen">Campo requerido</small>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													v-model="detalle.ciudad_destino" 
													:class="{'p-invalid': detalle.submitted && !detalle.ciudad_destino}"
												/>
												<label>Ciudad Destino*</label>
											</span>
											<small class="p-error" v-if="detalle.submitted && !detalle.ciudad_destino">Campo requerido</small>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													v-model="detalle.departamento_destino" 
													:class="{'p-invalid': detalle.submitted && !detalle.departamento_destino}"
												/>
												<label>Departamento Destino*</label>
											</span>
											<small class="p-error" v-if="detalle.submitted && !detalle.departamento_destino">Campo requerido</small>
										</div>

										<!-- Remitente -->
										<div class="col-12">
											<div class="section-header">
												<i class="pi pi-share-alt mr-2"></i>
												<span class="section-title">Remitente</span>
											</div>
										</div>

										<!-- Remitente -->
										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													id="send_id" 
													v-model="detalle.send_id" 
													:class="{'p-invalid': submitted && !detalle.send_id}"
													type="number"
												/>
												<label for="send_id">Documento del Remitente*</label>
											</span>
											<small class="p-error" v-if="submitted && !detalle.send_id">El documento del remitente es requerido</small>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													id="send_name" 
													v-model="detalle.send_name" 
													:class="{'p-invalid': submitted && !detalle.send_name}"
												/>
												<label for="send_name">Nombre del Remitente*</label>
											</span>
											<small class="p-error" v-if="submitted && !detalle.send_name">El nombre del remitente es requerido</small>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													id="send_city" 
													v-model="detalle.send_city" 
													:class="{'p-invalid': submitted && !detalle.send_city}"
												/>
												<label for="send_city">Ciudad del Remitente*</label>
											</span>
											<small class="p-error" v-if="submitted && !detalle.send_city">La ciudad del remitente es requerida</small>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													id="send_country" 
													v-model="detalle.send_country" 
													:class="{'p-invalid': submitted && !detalle.send_country}"
												/>
												<label for="send_country">Departamento del Remitente*</label>
											</span>
											<small class="p-error" v-if="submitted && !detalle.send_country">El departamento del remitente es requerido</small>
										</div>

										<!-- Destinatario -->
										<div class="col-12">
											<div class="section-header">
												<i class="pi pi-share-alt mr-2"></i>
												<span class="section-title">Destinatario</span>
											</div>
										</div>

										<!-- Destinatario -->
										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													id="received_id" 
													v-model="detalle.received_id" 
													:class="{'p-invalid': submitted && !detalle.received_id}"
													type="number"
												/>
												<label for="received_id">Documento del Destinatario*</label>
											</span>
											<small class="p-error" v-if="submitted && !detalle.received_id">El documento del destinatario es requerido</small>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													id="received_name" 
													v-model="detalle.received_name" 
													:class="{'p-invalid': submitted && !detalle.received_name}"
												/>
												<label for="received_name">Nombre del Destinatario*</label>
											</span>
											<small class="p-error" v-if="submitted && !detalle.received_name">El nombre del destinatario es requerido</small>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													id="received_city" 
													v-model="detalle.received_city" 
													:class="{'p-invalid': submitted && !detalle.received_city}"
												/>
												<label for="received_city">Ciudad del Destinatario*</label>
											</span>
											<small class="p-error" v-if="submitted && !detalle.received_city">La ciudad del destinatario es requerida</small>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													id="received_country" 
													v-model="detalle.received_country" 
													:class="{'p-invalid': submitted && !detalle.received_country}"
												/>
												<label for="received_country">Departamento del Destinatario*</label>
											</span>
											<small class="p-error" v-if="submitted && !detalle.received_country">El departamento del destinatario es requerido</small>
										</div>


										<!-- Información del Producto -->
										<div class="col-12">
											<div class="subsection-header">
												<i class="pi pi-shopping-bag mr-2"></i>
												<span>Información del Producto</span>
											</div>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													v-model="detalle.producto" 
													:class="{'p-invalid': detalle.submitted && !detalle.producto}"
												/>
												<label>Producto*</label>
											</span>
											<small class="p-error" v-if="detalle.submitted && !detalle.producto">Campo requerido</small>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText v-model="detalle.empaque" />
												<label>Empaque</label>
											</span>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputNumber 
													v-model="detalle.peso" 
													:class="{'p-invalid': detalle.submitted && !detalle.peso}"
													suffix=" kg"
												/>
												<label>Peso (kg)*</label>
											</span>
											<small class="p-error" v-if="detalle.submitted && !detalle.peso">Campo requerido</small>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputNumber 
													v-model="detalle.unidades" 
													:class="{'p-invalid': detalle.submitted && !detalle.unidades}"
												/>
												<label>Unidades*</label>
											</span>
											<small class="p-error" v-if="detalle.submitted && !detalle.unidades">Campo requerido</small>
										</div>

										<!-- Cliente -->
										<div class="col-12">
											<div class="subsection-header">
												<i class="pi pi-user mr-2"></i>
												<span>Cliente</span>
											</div>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													v-model="detalle.id_cliente" 
													:class="{'p-invalid': detalle.submitted && !detalle.id_cliente}"
													type="number"
												/>
												<label>ID Cliente*</label>
											</span>
											<small class="p-error" v-if="detalle.submitted && !detalle.id_cliente">Campo requerido</small>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText 
													v-model="detalle.nombre_cliente" 
													:class="{'p-invalid': detalle.submitted && !detalle.nombre_cliente}"
												/>
												<label>Nombre Cliente*</label>
											</span>
											<small class="p-error" v-if="detalle.submitted && !detalle.nombre_cliente">Campo requerido</small>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText v-model="detalle.direccion" />
												<label>Dirección</label>
											</span>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText v-model="detalle.ciudad_cliente" />
												<label>Ciudad</label>
											</span>
										</div>

										<div class="col-12 lg:col-4">
											<span class="p-float-label">
												<InputText v-model="detalle.departamento_cliente" />
												<label>Departamento</label>
											</span>
										</div>

										<div class="col-12 lg:col-4">
											<span class="p-float-label">
												<InputText v-model="detalle.email" type="email" />
												<label>Email</label>
											</span>
										</div>

										<div class="col-12 lg:col-4">
											<span class="p-float-label">
												<InputText v-model="detalle.telefono" />
												<label>Teléfono</label>
											</span>
										</div>

										<div class="col-12 lg:col-6">
											<span class="p-float-label">
												<InputText v-model="detalle.celular" />
												<label>Celular</label>
											</span>
										</div>
									</div>
								</AccordionTab>
							</Accordion>
						</div>

						<!-- Tabla de Resumen de Detalles -->
						<div class="col-12 mt-4" v-if="detalles_viaje.length > 0">
							<div class="section-header">
								<i class="pi pi-list mr-2"></i>
								<span class="section-title">Resumen de Detalles ({{detalles_viaje.length}})</span>
							</div>
						</div>

						<div class="col-12" v-if="detalles_viaje.length > 0">
							<DataTable 
								:value="detalles_viaje" 
								responsiveLayout="scroll"
								class="detalles-table"
								:paginator="true"
								:rows="5"
							>
								<Column field="index" header="#" style="width: 60px">
									<template #body="slotProps">
										<Tag :value="slotProps.index + 1" severity="info" />
									</template>
								</Column>
								<Column header="Origen">
									<template #body="slotProps">
										<div class="text-sm">
											<strong>{{slotProps.data.ciudad_origen}}</strong><br>
											<span class="text-500">{{slotProps.data.departamento_origen}}</span>
										</div>
									</template>
								</Column>
								<Column header="Destino">
									<template #body="slotProps">
										<div class="text-sm">
											<strong>{{slotProps.data.ciudad_destino}}</strong><br>
											<span class="text-500">{{slotProps.data.departamento_destino}}</span>
										</div>
									</template>
								</Column>
								<Column field="producto" header="Producto" />
								<Column header="Peso/Unidades">
									<template #body="slotProps">
										<div class="text-sm">
											<Tag severity="success">{{slotProps.data.peso}} kg</Tag>
											<Tag severity="info" class="ml-1">{{slotProps.data.unidades}} uds</Tag>
										</div>
									</template>
								</Column>
								<Column field="nombre_cliente" header="Cliente" />
								<Column header="Acciones" style="width: 100px">
									<template #body="slotProps">
										<Button 
											icon="pi pi-trash" 
											class="p-button-rounded p-button-danger p-button-text"
											@click="eliminarDetalle(slotProps.index)"
										/>
									</template>
								</Column>
							</DataTable>
						</div>

						<div class="col-12" v-else>
							<Message severity="warn" :closable="false">
								<i class="pi pi-exclamation-triangle mr-2"></i>
								No hay detalles agregados. Haga clic en "Agregar Detalle" para comenzar.
							</Message>
						</div>
					</div>
				</TabPanel>

				<!-- TAB 2: IMPORTAR EXCEL -->
				<TabPanel>
					<template #header>
						<span class="flex align-items-center gap-2">
							<i class="pi pi-upload mr-1"></i>
							<span class="font-semibold">Importar Excel</span>
						</span>
					</template>
					
					<div class="grid p-fluid">
						<!-- Header de importación -->
						<div class="col-12">
							<div class="import-header">
								<div class="import-icon">
									<i class="pi pi-cloud-upload"></i>
								</div>
								<h3>Importar Viajes desde Excel</h3>
								<p>Descargue la plantilla, complete la información en las dos pestañas (Información General y Detalles) y cargue el archivo para crear viajes masivamente.</p>
							</div>
						</div>

						<!-- Botón de descarga de plantilla -->
						<div class="col-12">
							<div class="download-template-card">
								<div class="template-icon">
									<i class="pi pi-file-excel"></i>
								</div>
								<div class="template-info">
									<h4>Plantilla de Excel</h4>
									<p>Descargue la plantilla oficial para importar viajes</p>
									<Button 
										label="Descargar Plantilla Excel" 
										icon="pi pi-download" 
										class="p-button-success"
										@click="descargarPlantilla"
									/>
								</div>
								
							</div>
							
						</div>

						<!-- Área de carga de archivo -->
						<div class="col-12">
							<div class="upload-area" :class="{'drag-over': isDragging}">
								<i class="pi pi-cloud-upload upload-icon"></i>
								<h4>Seleccione un archivo Excel o CSV</h4>
								<p>Arrastre y suelte su archivo aquí o haga clic para seleccionar</p>
								<FileUpload 
									mode="basic" 
									accept=".xlsx,.xls,.csv"
									:maxFileSize="10000000"
									chooseLabel="Seleccionar Archivo"
									class="mt-3"
									@select="onFileSelect"
								/>
								<small class="text-500 mt-2">Formatos aceptados: .xlsx, .xls, .csv (máximo 10MB)</small>
							</div>
						</div>

						<!-- Información del archivo seleccionado -->
						<div class="col-12" v-if="archivoSeleccionado">
							<div class="file-info-card">
								<i class="pi pi-file text-4xl text-primary"></i>
								<div class="file-details">
									<h4>{{archivoSeleccionado.name}}</h4>
									<p>Tamaño: {{formatFileSize(archivoSeleccionado.size)}}</p>
								</div>
								<Button 
									icon="pi pi-times" 
									class="p-button-rounded p-button-danger p-button-text"
									@click="eliminarArchivo"
								/>
							</div>
						</div>

						<!-- Instrucciones importantes -->
						<div class="col-12">
							<div class="instructions-card">
								<div class="instruction-header">
									<i class="pi pi-info-circle mr-2"></i>
									<span>Instrucciones Importantes:</span>
								</div>
								<ul class="instruction-list">
									<li>La plantilla contiene dos pestañas: <strong>"Información General"</strong> y <strong>"Detalles"</strong></li>
									<li>Complete una fila en "Información General" con los datos del viaje</li>
									<li>Complete tantas filas como detalles tenga el viaje en la pestaña "Detalles"</li>
									<li>Los campos marcados con asterisco (*) en la plantilla son obligatorios</li>
									<li>Respete los formatos de fecha (YYYY-MM-DD HH:mm:ss) y números</li>
									<li>Para ciudades use los códigos de la maestra DIVIPOLA</li>
									<li>El sistema validará la estructura antes de importar</li>
								</ul>
							</div>
						</div>
					</div>
				</TabPanel>
			</TabView>

			<template #footer>
				<div class="flex justify-content-between align-items-center w-full">
					<div class="text-sm text-500">
						<i class="pi pi-info-circle mr-1"></i>
						Los campos marcados con * son obligatorios
					</div>
					<div class="flex gap-2">
						<Button 
							label="Cancelar" 
							icon="pi pi-times" 
							:loading="loader" 
							class="p-button-text" 
							@click="cerrarModal"
						/>
						<Button 
							label="Guardar Viaje" 
							:loading="loader" 
							icon="pi pi-save"
							class="p-button-primary" 
							@click="guardarViaje" 
						/>
					</div>
				</div>
			</template>
		</Dialog>
	</div>
</template>

<script>
import TabViewMovimiento from './components/TabViewMovimiento.vue'
export default {
	data() {
		return {
			expandedViajeId: null,
			message: [],
			customers: [],
			indicadores_viajes: [],
			activeIndex: 0,
			username:null,
			selectgenerador: null,
			pieDataViajes: null,
			barDataViajes: null,
			barDataViajesLine: null,
			barOptionsVer: null,
			deliveries: [],
			loader: false,
			email:null,
			barOptions: null,
			pieOptions: null,
			cartera: 0,
			estado_viaje: 0,
			estado_viaje_descripcion: '',
			centro_costos: [],
			expandedRows: [],
			pagination: {
				current_page: 0,
				from: 0,
				last_page: 0,
				per_page: 0,
				to: 0,
				total: 0
			},
			frmfiltros: {
                fechasolicitud: null,
                rangofechasolicitud: false,
                fechasolicitudrango: null,
                placa: '',
                conductor_documento: '',
            },
			// Formulario principal
			frmUsuario: {
				email: '',
				placa: '',
				tipo_despacho: null,
				reference_document: '',
				valor_viaje: null,
				representative_id: '',
				representative: '',
				owner_id: '',
				owner: '',
				hours_validation: '',
				required_firm: 0,
				required_check: 0
			},
			count: 0,
			// Detalles del viaje
			detalles_viaje: [],
			activeAccordions: [],

			// Importación Excel
			archivoSeleccionado: null,
			isDragging: false,
			selectedProducts: null,
			items: [
					{label: 'Update', icon: 'pi pi-fw pi-refresh'},
					{label: 'Edit', icon: 'pi pi-fw pi-pencil'}
				],
			modal_crear_viaje: false,
			titulo_modal: '',
			perfiles_disponibles: [],
			tiposIdentificacion: [
				{ label: 'Cédula de Ciudadanía', value: 'CC' },
				{ label: 'Cédula de Extranjería', value: 'CE' },
				{ label: 'Pasaporte', value: 'PP' },
				{ label: 'NIT', value: 'NIT' }
			],
			tipos_despachos: [],
			ingresoCostumer: false
		}
	},
	components: {
        'TabViewMovimiento': TabViewMovimiento,
    },
	mounted(){
		this.cargargeneradorescustomer();
	},
	methods:{
		getEventoClass(id_event) {
		const classes = {
			2: 'llegada', 3: 'carga', 4: 'carga', 5: 'aceptado',
			6: 'llegada', 7: 'descarga', 8: 'descarga', 9: 'aceptado',
			10: 'pendiente', 11: 'exitoso', 12: 'rechazado'
		};
		return classes[id_event] || 'default';
		},
		getEventoIcon(id_event) {
		const icons = {
			2: 'pi-truck', 3: 'pi-box', 4: 'pi-check', 5: 'pi-check-circle',
			6: 'pi-building', 7: 'pi-download', 8: 'pi-check', 9: 'pi-check-circle',
			10: 'pi-clock', 11: 'pi-verified', 12: 'pi-times-circle'
		};
		return `pi ${icons[id_event] || 'pi-circle'}`;
		},
		getEventoTitulo(id_event) {
		const titulos = {
			2: 'LLEGADA AL LUGAR DEL DESCARGUE', 
			3: 'ENTRADA AL LUGAR DEL DESCARGUE',
			4: 'SALIDA DEL LUGAR DEL DESCARGUE',
			5: 'CARGA ACEPTADA',
			6: 'INICIO VIAJE',
			7: 'INICIO DESCARGUE',
			8: 'FIN DESCARGUE',
			9: 'DESCARGA ACEPTADA',
			10: 'ENTREGA PENDIENTE',
			11: 'ENTREGA EXITOSA',
			12: 'ENTREGA RECHAZADA'
		};
		return titulos[id_event] || 'EVENTO';
		},
		formatDate(dateString) {
		const date = new Date(dateString);
		return date.toLocaleString('es-CO', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
			hour12: true
		});
		},
		scrollTimeline(direction) {
		const timeline = document.querySelector('.timeline-track');
		const scrollAmount = 300;
		if (timeline) {
			timeline.scrollBy({
			left: direction === 'left' ? -scrollAmount : scrollAmount,
			behavior: 'smooth'
			});
		}
		},
		openMapModal(evento) {
		const url = `https://www.google.com.co/maps?q=${evento.latitude},${evento.longitude}`;
		window.open(url, '_blank');
		},
		openGaleriaEventos(imagenes) {
		this.img_eventos = [];
		this.loader = true;
		
		window.api.call('post', 'img_public', {
			imagenes: imagenes,
			nombre_campo_img: 'image_url'
		}).then(response => {
			if (response.status === 200) {
			this.loader = false;
			this.img_eventos = response.data.data.images;
			this.show_galeria_evnets = true;
			}
		}).catch(err => {
			this.loader = false;
			console.error(err);
		});
		},
		toggleViaje(viaje) {
			const id = viaje.id_viaje;

			this.expandedViajeId = this.expandedViajeId === id
				? null
				: id;
		},
		isViajeExpanded(viaje) {
			return this.expandedViajeId === viaje.id_viaje;
		},
		formatDate(dateString) {
			return new Date(dateString).toLocaleDateString('es-CO', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric'
			});
		},
		getEstadoSeverity(estado) {
			const severityMap = {
				'PENDIENTE': 'warning',
				'ACEPTADO': 'info',
				'EN TRANSITO': 'primary',
				'FINALIZADO': 'success',
				'RECHAZADO': 'danger'
			};
			return severityMap[estado] || 'secondary';
		},
		toggle(event) {
			this.$refs.op.toggle(event);
		},
		onRowClick(event) {
			const selectedRow = event.data;
			const rowIndex = this.deliveries.indexOf(selectedRow);

			if (rowIndex !== -1) {
				if (this.expandedRows.includes(selectedRow)) {
				this.expandedRows.splice(this.expandedRows.indexOf(selectedRow), 1);
				} else {
				this.expandedRows.push(selectedRow);
				}
			}
		},
		// Cerrar modal
		cerrarModal() {
			this.modal_crear_viaje = false;
			this.limpiarFormulario();
		},
		// Limpiar formulario
		limpiarFormulario() {
			this.frmUsuario = {
				email: '',
				placa: '',
				tipo_despacho: null,
				reference_document: '',
				valor_viaje: null,
				representative_id: '',
				representative: '',
				owner_id: '',
				owner: '',
				hours_validation: '',
				required_firm: 0,
				required_check: 0
			};
			this.detalles_viaje = [];
			this.activeAccordions = [];
			this.submitted = false;
			this.archivoSeleccionado = null;
		},
		// Agregar nuevo detalle
		agregarDetalle() {
			const nuevoDetalle = {
				secuencia: this.detalles_viaje.length + 1,
				ciudad_origen: '',
				departamento_origen: '',
				ciudad_destino: '',
				departamento_destino: '',
				producto: '',
				empaque: '',
				peso: null,
				unidades: null,
				id_cliente: '',
				nombre_cliente: '',
				direccion: '',
				ciudad_cliente: '',
				departamento_cliente: '',
				email: '',
				telefono: '',
				celular: '',
				submitted: false
			};
			this.detalles_viaje.push(nuevoDetalle);
			
			// Abrir automáticamente el nuevo acordeón
			this.activeAccordions.push(this.detalles_viaje.length - 1);
			
			this.$toast.add({
				severity: 'success',
				summary: 'Detalle agregado',
				detail: `Detalle #${nuevoDetalle.secuencia} agregado correctamente`,
				life: 3000
			});
		},

		// Eliminar detalle
		eliminarDetalle(index) {
			this.detalles_viaje.splice(index, 1);
			
			// Reorganizar secuencias
			this.detalles_viaje.forEach((detalle, idx) => {
				detalle.secuencia = idx + 1;
			});
			
			this.$toast.add({
				severity: 'success',
				summary: 'Detalle eliminado',
				detail: 'El detalle ha sido eliminado correctamente',
				life: 3000
			});
		},

		// Validar detalles
		validarDetalles() {
			let todosValidos = true;
			
			this.detalles_viaje.forEach(detalle => {
				detalle.submitted = true;
				
				const camposRequeridos = [
					'ciudad_origen',
					'departamento_origen',
					'ciudad_destino',
					'departamento_destino',
					'producto',
					'peso',
					'unidades',
					'id_cliente',
					'nombre_cliente',
					'send_id',
					'send_name',
					'send_city',
					'send_country',
					'received_id',
					'received_name',
					'received_city',
					'received_country'
				];
				
				const detalleValido = camposRequeridos.every(campo => {
					return detalle[campo] !== '' && detalle[campo] !== null;
				});
				
				if (!detalleValido) {
					todosValidos = false;
				}
			});
			
			return todosValidos;
		},

		// Validar formulario principal
		validarFormularioPrincipal() {
			this.submitted = true;
			
			const camposRequeridos = [
				'email',
				'placa',
				'tipo_despacho',
				'reference_document',
				'valor_viaje',
				'representative_id',
				'representative',
				'owner_id',
				'owner',
				'hours_validation'
			];
			
			return camposRequeridos.every(campo => {
				return this.frmUsuario[campo] !== '' && this.frmUsuario[campo] !== null;
			});
		},
		get_type_dispatch(){
			this.loader = true;
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			this.tipos_despachos = [];
			// Llamada al API
			window.api.call('post', '/get_type_dispatch', {email: email,id_rol: id_rol})
				.then(response => {
					if (response.status === 200) {
						_that.tipos_despachos = response.data.data;
						_that.modal_crear_viaje = true;
					}
				})
				.catch(error => {
					console.error('Error al crear viaje:', error);
					this.$toast.add({
						severity: 'error',
						summary: 'Error',
						detail: 'Ocurrió un error al crear el viaje',
						life: 5000
					});
				})
				.finally(() => {
					this.loader = false;
				});
		},

		// Guardar viaje
		guardarViaje() {
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var id_rol = cookie[IdRol];
			var _that = this;
			// Validar formulario principal
			if (!this.validarFormularioPrincipal()) {
				this.$toast.add({
					severity: 'error',
					summary: 'Error de validación',
					detail: 'Por favor complete todos los campos obligatorios del formulario',
					life: 5000
				});
				return;
			}

			// Validar que haya al menos un detalle
			if (this.detalles_viaje.length === 0) {
				this.$toast.add({
					severity: 'error',
					summary: 'Error de validación',
					detail: 'Debe agregar al menos un detalle de entrega',
					life: 5000
				});
				return;
			}

			// Validar detalles
			if (!this.validarDetalles()) {
				this.$toast.add({
					severity: 'error',
					summary: 'Error de validación',
					detail: 'Por favor complete todos los campos obligatorios de los detalles',
					life: 5000
				});
				return;
			}

			// Preparar datos para enviar
			const datosViaje = {
				...this.frmUsuario,
				detalles: this.detalles_viaje
			};

			this.loader = true;

			// Llamada al API
			window.api.call('post', '/crear_viaje', {viaje: datosViaje,id_rol: id_rol})
				.then(response => {
					if (response.status === 200) {
						_that.$toast.add({
							severity: 'success',
							summary: 'Viaje creado',
							detail: 'El viaje ha sido creado exitosamente',
							life: 3000
						});
						
						_that.modal_crear_viaje = false;
						_that.cargar_detalle(1);
					}
				})
				.catch(error => {
					console.error('Error al crear viaje:', error);
					if (error.data.data.message) {
						if (error.data.data.message.length>0) {
							error.data.data.message.forEach(element => {
								_that.$toast.add({
									severity: 'error',
									summary: 'Error',
									detail: element,
									life: 5000
								});
							});
						}else{
							_that.$toast.add({
								severity: 'error',
								summary: 'Error',
								detail: error.data.data.message,
								life: 5000
							});
						}
						
					}else{
						_that.$toast.add({
							severity: 'error',
							summary: 'Error',
							detail: 'Ocurrió un error al crear el viaje',
							life: 5000
						});
					}
					
					
				})
				.finally(() => {
					_that.loader = false;
				});
		},

		// Manejo de archivos Excel
		onFileSelect(event) {
			this.archivoSeleccionado = event.files[0];
			this.$toast.add({
				severity: 'success',
				summary: 'Archivo seleccionado',
				detail: `${this.archivoSeleccionado.name} cargado correctamente`,
				life: 3000
			});
		},

		eliminarArchivo() {
			this.archivoSeleccionado = null;
			this.$toast.add({
				severity: 'info',
				summary: 'Archivo eliminado',
				detail: 'El archivo ha sido eliminado',
				life: 3000
			});
		},

		formatFileSize(bytes) {
			if (bytes === 0) return '0 Bytes';
			const k = 1024;
			const sizes = ['Bytes', 'KB', 'MB', 'GB'];
			const i = Math.floor(Math.log(bytes) / Math.log(k));
			return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
		},

		descargarPlantilla() {
			// Aquí implementarías la descarga de la plantilla Excel
			this.$toast.add({
				severity: 'info',
				summary: 'Descargando plantilla',
				detail: 'La plantilla se está descargando...',
				life: 3000
			});
		},

		// Manejo de drag & drop
		onDragEnter(event) {
			event.preventDefault();
			this.isDragging = true;
		},

		onDragLeave(event) {
			event.preventDefault();
			this.isDragging = false;
		},

		onDrop(event) {
			event.preventDefault();
			this.isDragging = false;
			
			const files = event.dataTransfer.files;
			if (files.length > 0) {
				const file = files[0];
				const validExtensions = ['.xlsx', '.xls', '.csv'];
				const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
				
				if (validExtensions.includes(fileExtension)) {
					this.archivoSeleccionado = file;
					this.$toast.add({
						severity: 'success',
						summary: 'Archivo cargado',
						detail: `${file.name} cargado correctamente`,
						life: 3000
					});
				} else {
					this.$toast.add({
						severity: 'error',
						summary: 'Formato inválido',
						detail: 'Por favor seleccione un archivo Excel o CSV',
						life: 5000
					});
				}
			}
		},
		cleartable(){
			this.indicadores_viajes = [];
			this.pagination.current_page = 0;
				this.pagination.from= 0;
				this.pagination.last_page= 0;
				this.pagination.per_page= 0;
				this.pagination.to= 0;
				this.pagination.total= 0;
		},
		limpiar(){
			this.frmfiltros = {
				fechasolicitud: null,
				fechasolicitudrango: null,
				placa: '',
				conductor_documento: ''
			};
			this.cargar_detalle(1);
		},
		onChangePage(event) {
			this.cargar_detalle(event.page + 1);
		},
		openModalNuevoViaje(){
			this.get_type_dispatch();
            this.titulo_modal = 'Crear Viaje';
			this.submitted = false;
			this.frmUsuario = {
				id: 0,
				reference_document: '',
				placa: '',
				tipo_despacho: '',
				valor_viaje: 0,
				representative_id: '',
				representative: '',
				owner_id: '',
				owner: '',
				hours_validation: 24,
				email: ''
			};
		},
		cargargeneradorescustomer(){
			const cookieName = 'Email';
				const IdRol = 'IdRol';
				this.loader = true;
				this.customers = [];
				let cookie = {};
				document.cookie.split(';').forEach(function(el) {
				let [key,value] = el.split('=');
				cookie[key.trim()] = value;
				})
				var email = cookie[cookieName];
				var id_rol = cookie[IdRol];
			this.cleartable();
			this.loader = true;
			this.indicadores_viajes = [];
			var _that = this;
                window.api.call('post', '/cargar_idicadores_viajes', {email: email,id_rol: id_rol}).then( function(response) {
                    if(response.status == 200){
							_that.indicadores_viajes = response.data.indicadores_viajes;

							_that.pieOptions = _that.getPieChartOptions();
							_that.pieDataViajes = _that.getpieDataViajes();

							_that.barDataViajes = _that.getpieDataBarViajes(false);
							_that.barDataViajesLine = _that.getpieDataBarViajes(true);

							_that.barOptions = _that.getBarChartOptions();
							_that.barOptionsVer = _that.getBarChartOptionsVertical();
							_that.loader = false;
                    }
                }).catch(function (err) {
                    console.log(err);
					_that.loader = false;
                });
		},
		getpieDataViajes() {
            const documentStyle = getComputedStyle(document.body);

            return {
                labels: ['PENDIENTES', 'ACEPTADOS', 'EN TRANSITO', 'FINALIZADO'],
                datasets: [
                    {
                        data: [this.indicadores_viajes.total_pendiente ?? 0, this.indicadores_viajes.total_aceptado ?? 0, this.indicadores_viajes.total_transito ?? 0, this.indicadores_viajes.total_finalizado ?? 0],
                        backgroundColor: [documentStyle.getPropertyValue('--blue-300'), documentStyle.getPropertyValue('--green-400'),documentStyle.getPropertyValue('--yellow-300'),documentStyle.getPropertyValue('--purple-300')],
                        hoverBackgroundColor: [documentStyle.getPropertyValue('--blue-400'), documentStyle.getPropertyValue('--green-400'), documentStyle.getPropertyValue('--yellow-400'), documentStyle.getPropertyValue('--purple-400')]
                    }
                ]
            };
        },
		getPieChartOptions() {
			const documentStyle = getComputedStyle(document.documentElement);
            const textColor = documentStyle.getPropertyValue('--p-text-color');

            return {
                plugins: {
                    legend: {
                        labels: {
                            cutout: '60%',
                            color: textColor
                        }
                    }
                }
            };
        },
		getpieDataBarViajes(line) {
			const documentStyle = getComputedStyle(document.body);
            const isLight = this.$appState.layoutMode === 'light';
            const dataset1Color = isLight ? '#00ACC1' : '#4DD0E1';
			var lines = line;
			var datasets = [];
			var labels = [];
			this.total_facturado = 0;
			labels = ['PENDIENTES', 'ACEPTADOS', 'EN TRANSITO', 'FINALIZADO'];
			if (line == true) {
				datasets = [
					{
						type: 'line',
						label: 'Sales',
						data: [this.indicadores_viajes.total_pendiente ?? 0, this.indicadores_viajes.total_aceptado ?? 0, this.indicadores_viajes.total_transito ?? 0, this.indicadores_viajes.total_finalizado ?? 0],
						backgroundColor: [documentStyle.getPropertyValue('--blue-300'), documentStyle.getPropertyValue('--green-400'),documentStyle.getPropertyValue('--yellow-300'),documentStyle.getPropertyValue('--purple-300')],
						borderColor: [documentStyle.getPropertyValue('--blue-500'), documentStyle.getPropertyValue('--green-500'),documentStyle.getPropertyValue('--yellow-500'),documentStyle.getPropertyValue('--purple-500')],
						borderWidth: 1
					},
					{
						type: 'bar',
						label: 'Sales',
						data: [this.indicadores_viajes.total_pendiente ?? 0, this.indicadores_viajes.total_aceptado ?? 0, this.indicadores_viajes.total_transito ?? 0, this.indicadores_viajes.total_finalizado ?? 0],
						backgroundColor: [documentStyle.getPropertyValue('--blue-300'), documentStyle.getPropertyValue('--green-400'),documentStyle.getPropertyValue('--yellow-300'),documentStyle.getPropertyValue('--purple-300')],
						borderColor: [documentStyle.getPropertyValue('--blue-500'), documentStyle.getPropertyValue('--green-500'),documentStyle.getPropertyValue('--yellow-500'),documentStyle.getPropertyValue('--purple-500')],
						borderWidth: 1
					}
				];
			}else{
				datasets = [
					{
						type: 'bar',
						label: 'Sales',
						data: [this.indicadores_viajes.total_pendiente ?? 0, this.indicadores_viajes.total_aceptado ?? 0, this.indicadores_viajes.total_transito ?? 0, this.indicadores_viajes.total_finalizado ?? 0],
						backgroundColor: [documentStyle.getPropertyValue('--blue-300'), documentStyle.getPropertyValue('--green-400'),documentStyle.getPropertyValue('--yellow-300'),documentStyle.getPropertyValue('--purple-300')],
						borderColor: [documentStyle.getPropertyValue('--blue-500'), documentStyle.getPropertyValue('--green-500'),documentStyle.getPropertyValue('--yellow-500'),documentStyle.getPropertyValue('--purple-500')],
						borderWidth: 1
					}
				];
			}
			
            return {
				labels: labels,
				datasets: datasets
            };
        },
		getBarChartOptionsVertical() {
            return {
				indexAxis: 'y',
				responsive: true,
				legend: {
					display: false, // Oculta los labels de la parte superior
				},
				plugins: {
					legend: {
						display: false
					},
					tooltip: {
						callbacks: {
						label: (context) => {
							const label = context.chart.data.labels[context.dataIndex];
							const dataValue = context.chart.data.datasets[0].data[context.dataIndex];
							const total = context.chart.data.datasets[0].data.reduce((acc, curr) => acc + curr, 0);
							const percentage = ((dataValue / total) * 100).toFixed(2);
							// const value = context.chart.data.datasets[0].data[context.dataIndex];
							const value = new Intl.NumberFormat().format(context.chart.data.datasets[0].data[context.dataIndex]);
							// value = ;
							return `${label}: $${value}  (${percentage}%)`;
						}
						}
					},
				}
            }
        },
		getBarChartOptions() {
            return {
				responsive: true,
				scales: {
					y: {
						beginAtZero: true,
					},
				},
				legend: {
					display: false, // Oculta los labels de la parte superior
				},
				plugins: {
					legend: {
						display: false
					},
					tooltip: {
						callbacks: {
						label: (context) => {
							const label = context.chart.data.labels[context.dataIndex];
							const dataValue = context.chart.data.datasets[0].data[context.dataIndex];
							const total = context.chart.data.datasets[0].data.reduce((acc, curr) => acc + curr, 0);
							const percentage = ((dataValue / total) * 100).toFixed(2);
							// const value = context.chart.data.datasets[0].data[context.dataIndex];
							const value = new Intl.NumberFormat().format(context.chart.data.datasets[0].data[context.dataIndex]);
							// value = ;
							return `${label}: $${value}  (${percentage}%)`;
						}
						}
					},
				}
            }
        },
		salirCustomer(){
			this.ingresoCostumer = false;
		},
		selectindicador(indicador){
			// this.cleartable();
			switch (indicador) {
				case 1:
						this.estado_viaje = 1;
						this.estado_viaje_descripcion = 'VIAJES PENDIENTES';
					break;
				case 2:
						this.estado_viaje = 2;
						this.estado_viaje_descripcion = 'VIAJES ACEPTADOS';
					break;
				case 3:
						this.estado_viaje = 3;
						this.estado_viaje_descripcion = 'VIAJES EN TRANSITO';
					break;
				case 4:
						this.estado_viaje = 4;
						this.estado_viaje_descripcion = 'VIAJES FINALIZADOS';
					break;
				case 6:
						this.estado_viaje = 6;
						this.estado_viaje_descripcion = 'VIAJES RECHAZADOS';
					break;
				case 10:
						this.estado_viaje = 10;
						this.estado_viaje_descripcion = 'VIAJES';
					break;
				default:
					break;
			}
			// console.log(indicador);
			// console.log(this.estado_viaje);
			this.loader = true;
			this.limpiar();
		},
		cargar_detalle(page){
			const cookieName = 'Email';
				const IdRol = 'IdRol';
				this.loader = true;
				this.customers = [];
				let cookie = {};
				document.cookie.split(';').forEach(function(el) {
				let [key,value] = el.split('=');
				cookie[key.trim()] = value;
				})
				var email = cookie[cookieName];
				var id_rol = cookie[IdRol];
			this.loader = true;
			var _that = this;
			if(this.frmfiltros.placa){
				this.frmfiltros.placa = this.frmfiltros.placa.replaceAll('-', '');
			}
			this.deliveries = [];
                window.api.call('post', '/cargar_deliveries?&page='+page, {email: email,id_rol: id_rol,estado_viaje: this.estado_viaje,frmfiltros: this.frmfiltros}).then( function(response) {
                    if(response.status == 200){
						_that.pagination = response.data.data;
						_that.deliveries = response.data.data.data;
						_that.loader = false;
						_that.$refs.op.hide();
							
                    }
                }).catch(function (err) {
                    console.log(err);
					_that.loader = false;
                });
		}
	},
	computed: {
			isRTL() {
				return this.$appState.RTL;
			},
			validMinDate() {
				return this.frmfiltros.fechasolicitud ? new Date(this.frmfiltros.fechasolicitud) : null;
			}
		}
}
</script>

<style scoped lang="scss">
:root {
	--primary: #1a5f7a;
	--primary-light: #e8f2f7;
	--accent: #57c5b6;
	--accent-light: #e8f7f5;
	--surface: #ffffff;
	--surface-secondary: #f8fafb;
	--text-primary: #1e293b;
	--text-secondary: #64748b;
	--border: #e2e8f0;
	--success: #10b981;
	--success-light: #d1fae5;
	--warning: #f59e0b;
	--warning-light: #fef3c7;
	--error: #ef4444;
	--error-light: #fee2e2;
	--info: #3b82f6;
	--info-light: #dbeafe;
}

.tabla-viajes{
	font-size: 0.9rem;
}

.p-datatable table {
	width: 100%;
	border-collapse: collapse;
    min-width: 100%;
    table-layout: fixed;
}

.viajes-container-modern {
	background: var(--surface-secondary);
	min-height: 100vh;
	padding: 1.5rem;
}

// Header
.viajes-header-modern {
	background: var(--surface);
	border-radius: 12px;
	padding: 1.25rem 1.5rem;
	margin-bottom: 1.5rem;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	border: 1px solid var(--border);

	.header-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 1rem;
		flex-wrap: wrap;
	}

	.header-left {
		display: flex;
		align-items: center;
		gap: 1rem;
		flex: 1;
	}

	.header-title {
		h2 {
			margin: 0;
			font-size: 1.25rem;
			font-weight: 600;
			color: var(--text-primary);
		}

		.total-badge {
			display: inline-block;
			background: var(--primary-light);
			color: var(--primary);
			padding: 0.25rem 0.75rem;
			border-radius: 20px;
			font-size: 0.8125rem;
			font-weight: 600;
			margin-left: 0.5rem;
		}
	}

	.header-actions {
		display: flex;
		gap: 0.75rem;
		
		.p-button {
			font-size: 0.9375rem;
			padding: 0.625rem 1.25rem;
			border-radius: 8px;
		}
	}
}

// Panel de filtros
.filters-panel {
	padding: 1rem 0;

	.filters-title {
		display: flex;
		align-items: center;
		color: #1e293b;
		font-size: 1.125rem;
		font-weight: 600;
		margin-bottom: 1.5rem;
	}
}

// Viajes cards - diseño profesional pastel
.viajes-table-modern {
	display: flex;
	flex-direction: column;
	gap: 1rem;
}

.viaje-card-modern {
	background: var(--surface);
	border-radius: 10px;
	overflow: hidden;
	transition: all 0.2s ease;
	border: 1px solid var(--border);

	&:hover {
		transform: translateY(-1px);
	}

	.viaje-header {
		display: flex;
		align-items: center;
		padding: 1.25rem 1.5rem;
		cursor: pointer;
		transition: background 0.15s;
		border-bottom: 1px solid transparent;

		&:hover {
			background: #047857;
			// background: var(--surface-secondary);
		}
	}

	.viaje-info-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
		gap: 1.25rem;
		flex: 1;
	}

	.info-block {
		display: flex;
		gap: 0.875rem;
		align-items: flex-start;
	}

	.info-icon {
		width: 38px;
		height: 38px;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		font-size: 1.125rem;

		&.blue { 
			background: var(--info-light);
			color: var(--info);
		}
		&.green { 
			background: var(--success-light);
			color: var(--success);
		}
		&.orange { 
			background: var(--warning-light);
			color: var(--warning);
		}
		&.purple { 
			background: #f3e8ff;
			color: #9333ea;
		}
		&.pink { 
			background: #fce7f3;
			color: #ec4899;
		}
		&.teal { 
			background: #ccfbf1;
			color: #0d9488;
		}
	}

	.info-content {
		display: flex;
		flex-direction: column;
		gap: 0.25rem;
	}

	.info-label {
		font-size: 0.75rem;
		color: #64748b;
		text-transform: uppercase;
		font-weight: 600;
		letter-spacing: 0.5px;
	}

	.info-value {
		font-size: 1rem;
		color: #1e293b;
		font-weight: 700;
	}

	.info-sublabel {
		font-size: 0.875rem;
		color: #94a3b8;
	}

	.entregas-stats {
		display: flex;
		gap: 0.5rem;
		flex-wrap: wrap;
	}

	.expand-button {
		width: 40px;
		height: 40px;
		border-radius: 10px;
		background: #f1f5f9;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.3s;
		flex-shrink: 0;

		i {
			color: #64748b;
			font-size: 1rem;
		}

		&:hover {
			background: #e2e8f0;
		}
	}
}

// Contenido expandible
.viaje-content {
	border-top: 1px solid #f1f5f9;
	padding: 1.5rem;
	background: #fafbfc;
}

.expand-enter-active, .expand-leave-active {
	transition: all 0.3s ease;
	max-height: 1000px;
}

.expand-enter-from, .expand-leave-to {
	max-height: 0;
	opacity: 0;
}

// Tabs modernos
:deep(.viaje-tabs-modern) {
	.p-tabview-nav {
		background: white;
		border-radius: 12px;
		padding: 0.5rem;
		border: none;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

		.p-tabview-nav-link {
			border: none;
			padding: 0.75rem 1.25rem;
			border-radius: 8px;
			font-weight: 600;
			color: #64748b;
			transition: all 0.2s;

			&:hover {
				background: #f8fafb;
				color: #1e293b;
			}
		}

		.p-highlight .p-tabview-nav-link {
			background: #0A354E;
			color: white;
		}
	}

	.p-tabview-panels {
		background: white;
		border-radius: 12px;
		padding: 1.5rem;
		margin-top: 1rem;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
	}
}

// Empty state
.empty-state {
	text-align: center;
	padding: 4rem 2rem;
	background: white;
	border-radius: 16px;

	.empty-icon {
		font-size: 4rem;
		color: #cbd5e1;
		margin-bottom: 1rem;
	}

	h3 {
		color: #1e293b;
		margin-bottom: 0.5rem;
	}

	p {
		color: #64748b;
	}
}

// Paginación moderna
.pagination-modern {
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: white;
	padding: 1rem 1.5rem;
	border-radius: 16px;
	margin-top: 1.5rem;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

	.pagination-info {
		color: #64748b;
		font-size: 0.875rem;
		font-weight: 500;
	}
}

// Responsive
@media (max-width: 1024px) {
	.viaje-info-grid {
		grid-template-columns: repeat(3, 1fr);
	}
}

@media (max-width: 768px) {
	.viajes-container-modern {
		padding: 1rem;
	}

	.viajes-header-modern {
		.header-content {
			flex-direction: column;
			align-items: stretch;
		}

		.header-left {
			flex-direction: column;
			align-items: flex-start;
		}

		.header-actions {
			width: 100%;

			button {
				flex: 1;
			}
		}
	}

	.viaje-info-grid {
		grid-template-columns: repeat(2, 1fr);
	}

	.viaje-header {
		flex-direction: column;
		gap: 1rem;
	}

	.expand-button {
		align-self: stretch;
		width: 100%;
	}

	.pagination-modern {
		flex-direction: column;
		gap: 1rem;
	}
}

@media (max-width: 480px) {
	.viaje-info-grid {
		grid-template-columns: 1fr;
	}
}

@media (max-width: 480px) {
	.viaje-info-grid {
		grid-template-columns: 1fr;
	}
}
.widget-activity > li:nth-child(1) .p-progressbar-value {
    background: #75BEF8;
}
/* .indicadores-fijos{
	position: fixed;
    z-index: 1000;
	margin-left: 50px;
} */

.header-landing-seway{
    /* position: fixed; */
    z-index: 100;
    /* padding: 0rem 3rem 0rem 0rem; */
}
.p-menubar {
  /* padding: 0.75rem; */
  background: transparent;
/* //   color: rgba(255, 255, 255, 0.87); */
  border: 1px transparent;
  border-radius: 4px;
}
.button-menu-seway{
    background: #EB7D10;
    color: white;
}
.button-menu-seway:hover{
    background: #0A354E;
    color: white;
}

/* //moviles */
@media only screen and (max-width: 800px) {
    .landing-container #header .header-menu-container {
        z-index: 100;
        position: fixed;
        top: 0;
        left: 0;
        /* // width: 73%; */
        /* background: #212121; */
        /* padding: 2rem 1rem; */
    }
}
.dashboard-movimientos-container {
    background: linear-gradient(135deg, #ffffff 0%, #f8fcff 100%);
    min-height: 100vh;
}

/* // Header mejorado */
.dashboard-header-movimientos {
    text-align: center;
    color: rgb(0, 0, 0);
    margin-bottom: 3rem;
    margin-top: 2rem;
    animation: fadeInDown 0.6s ease-out;

    h1 {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 0.5rem;
        text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }

    p {
        font-size: 1.1rem;
        opacity: 0.9;
    }
}

/* // Grid de indicadores mejorado */
.indicators-modern-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
    margin-bottom: 3rem;
}

.indicator-card-modern {
    background: white;
    border-radius: 20px;
    padding: 1.5rem;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    animation: fadeInUp 0.6s ease-out backwards;

    &:nth-child(1) { animation-delay: 0.1s; }
    &:nth-child(2) { animation-delay: 0.2s; }
    &:nth-child(3) { animation-delay: 0.3s; }
    &:nth-child(4) { animation-delay: 0.4s; }
    &:nth-child(5) { animation-delay: 0.5s; }
    &:nth-child(6) { animation-delay: 0.6s; }

    &:hover {
        transform: translateY(-10px) scale(1.02);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);

        .indicator-icon-modern {
            transform: rotate(10deg) scale(1.1);
        }

        .indicator-badge-modern {
            opacity: 1;
        }
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 5px;
        background: linear-gradient(90deg, var(--color-start), var(--color-end));
    }

    &.total {
        --color-start: #0A354E;
        --color-end: #1a5f8f;
    }

    &.pendientes {
        --color-start: #60A5FA;
        --color-end: #3B82F6;
    }

    &.aceptados {
        --color-start: #34D399;
        --color-end: #10B981;
    }

    &.transito {
        --color-start: #FBBF24;
        --color-end: #F59E0B;
    }

    &.finalizado {
        --color-start: #A78BFA;
        --color-end: #8B5CF6;
    }

    &.rechazados {
        --color-start: #F472B6;
        --color-end: #EC4899;
    }
}

.indicator-icon-modern {
    width: 60px;
    height: 60px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    background: linear-gradient(135deg, var(--color-start), var(--color-end));
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease;
    font-size: 1.8rem;
}

.indicator-title-modern {
    font-size: 0.85rem;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.5rem;
}

.indicator-value-modern {
    font-size: 2.5rem;
    font-weight: 800;
    background: linear-gradient(135deg, var(--color-start), var(--color-end));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1;
}

.indicator-badge-modern {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: linear-gradient(135deg, var(--color-start), var(--color-end));
    color: white;
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.7rem;
    font-weight: 600;
    opacity: 0;
    transition: opacity 0.3s ease;
}

// Sección de gráficas mejorada
.charts-section-modern {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
    gap: 2rem;
    animation: fadeIn 0.8s ease-out 0.6s backwards;
}

.chart-card-modern {
    background: white;
    border-radius: 20px;
    padding: 2rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;

    &:hover {
        transform: translateY(-5px);
    }
}

.chart-header-modern {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.5rem;

    .chart-title-modern {
        font-size: 1.25rem;
        font-weight: 700;
        color: #1e293b;
    }

    .chart-icon-modern {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        background: linear-gradient(135deg, #105277, #0A354E);
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 1.2rem;
    }
}

.chart-wrapper-modern {
    height: 300px;
    margin-bottom: 1.5rem;

    :deep(.p-chart) {
        height: 100%;
        
        canvas {
            height: 100% !important;
        }
    }
}

.stats-grid-modern {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
}

.stat-item-modern {
    text-align: center;
    padding: 1rem;
    background: #f8fafc;
    border-radius: 12px;
    transition: all 0.3s ease;

    &:hover {
        background: #e2e8f0;
        transform: scale(1.05);
    }

    .stat-label-modern {
        font-size: 0.75rem;
        color: #64748b;
        text-transform: uppercase;
        margin-bottom: 0.5rem;
    }

    .stat-value-modern {
        font-size: 1.5rem;
        font-weight: 700;
        color: #1e293b;

        &.blue { color: #3B82F6; }
        &.green { color: #10B981; }
        &.orange { color: #F59E0B; }
        &.purple { color: #8B5CF6; }
        &.pink { color: #EC4899; }
        &.dark { color: #0A354E; }
    }
}

/* // Animaciones */
@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateY(-30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

/* // Responsive */
@media (max-width: 1024px) {
    .indicators-modern-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .charts-section-modern {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .dashboard-movimientos-container {
        padding: 1rem;
    }

    .dashboard-header-movimientos h1 {
        font-size: 1.8rem;
    }

    .indicators-modern-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
    }

    .indicator-value-modern {
        font-size: 2rem;
    }

    .stats-grid-modern {
        grid-template-columns: repeat(2, 1fr);
    }

    .chart-card-modern {
        padding: 1.5rem;
    }
}

@media (max-width: 480px) {
    .indicators-modern-grid {
        grid-template-columns: 1fr;
    }

    .indicator-card-modern {
        padding: 1.25rem;
    }

    .stats-grid-modern {
        grid-template-columns: 1fr;
    }
}
// Estilos para Modal Crear Viaje - Versión Limpia
:deep(.modal-crear-viaje) {
	.p-dialog-content {
		padding: 0 !important;
	}

	.p-tabview {
		.p-tabview-nav {
			background: #ffffff;
			border-bottom: 1px solid #e5e7eb;

			.p-tabview-nav-link {
				padding: 1rem 1.5rem;
				font-weight: 600;
				color: #6b7280;
				
				&:hover {
					background: #f9fafb;
					color: #374151;
				}
			}

			.p-highlight .p-tabview-nav-link {
				color: #0A354E;
				border-color: #062334;
			}
		}

		.p-tabview-panels {
			padding: 1.5rem;
			background: #fafafa;
		}
	}
}

// Headers de sección - más sutiles
.section-header {
	display: flex;
	align-items: center;
	padding: 0.875rem 1rem;
	background: #ffffff;
	border-left: 4px solid #0A354E;
	border-radius: 6px;
	margin-bottom: 1.25rem;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

	.section-title {
		font-size: 0.95rem;
		font-weight: 600;
		color: #1f2937;
	}

	i {
		font-size: 1.1rem;
		color: #0A354E;
		margin-right: 0.75rem;
	}
}

.section-header-detalles {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.875rem 1rem;
	background: #ffffff;
	border-left: 4px solid #10b981;
	border-radius: 6px;
	margin-bottom: 1.25rem;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

	.section-title {
		font-size: 0.95rem;
		font-weight: 600;
		color: #1f2937;
	}

	i {
		font-size: 1.1rem;
		color: #10b981;
		margin-right: 0.75rem;
	}

	.p-button {
		font-size: 0.875rem;
		padding: 0.5rem 1rem;
	}
}

.subsection-header {
	display: flex;
	align-items: center;
	padding: 0.625rem 1rem;
	background: #f9fafb;
	border-left: 3px solid #0A354E;
	border-radius: 4px;
	margin-bottom: 1rem;
	font-weight: 600;
	font-size: 0.9rem;
	color: #374151;

	i {
		color: #0A354E;
		font-size: 1rem;
	}
}

// Message info más sutil
:deep(.p-message.p-message-info) {
	background: #eff6ff;
	border: 1px solid #dbeafe;
	color: #1e40af;
	padding: 0.75rem 1rem;
	margin-bottom: 1rem;

	.p-message-icon {
		color: #3b82f6;
	}
}

:deep(.p-message.p-message-warn) {
	background: #fef3c7;
	border: 1px solid #fde68a;
	color: #92400e;
	padding: 0.75rem 1rem;

	.p-message-icon {
		color: #f59e0b;
	}
}


.accordion-header-custom {
	display: flex;
	align-items: center;
	gap: 1rem;
	width: 100%;

	.badge-detalle {
		background: #eef2ff;
		color: #0A354E;
		border: 1px solid #c7d2fe;
		padding: 0.25rem 0.75rem;
		border-radius: 6px;
		font-size: 0.8125rem;
		font-weight: 600;
	}

	.text-sm {
		color: #6b7280;
		font-size: 0.875rem;
	}
}

.detalle-form {
	background: #f9fafb;
	padding: 1.25rem;
	border-radius: 6px;
	border: 1px solid #e5e7eb;
}

// Tabla de resumen
:deep(.detalles-table) {
	.p-datatable-wrapper {
		border-radius: 8px;
		overflow: hidden;
	}

	.p-datatable-thead > tr > th {
		background: #f9fafb;
		color: #374151;
		font-weight: 600;
		padding: 0.875rem 1rem;
		border: none;
		border-bottom: 2px solid #e5e7eb;
		font-size: 0.875rem;
	}

	.p-datatable-tbody > tr {
		transition: all 0.2s ease;
		background: #ffffff;

		&:hover {
			background: #f9fafb;
		}

		> td {
			padding: 0.875rem 1rem;
			border-bottom: 1px solid #f3f4f6;
			font-size: 0.875rem;
		}
	}

	.p-tag {
		font-size: 0.75rem;
		padding: 0.25rem 0.5rem;
	}
}

// Tab de importación Excel
.import-header {
	text-align: center;
	padding: 2.5rem 2rem;
	background: #ffffff;
	border: 1px solid #e5e7eb;
	border-radius: 12px;
	margin-bottom: 1.5rem;

	.import-icon {
		width: 70px;
		height: 70px;
		margin: 0 auto 1.25rem;
		background: linear-gradient(135deg, #0f4e73 0%, #0A354E 100%);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);

		i {
			font-size: 2rem;
			color: white;
		}
	}

	h3 {
		color: #1f2937;
		font-size: 1.375rem;
		margin-bottom: 0.5rem;
		font-weight: 600;
	}

	p {
		color: #6b7280;
		font-size: 0.9375rem;
		max-width: 600px;
		margin: 0 auto;
		line-height: 1.6;
	}
}

.download-template-card {
	display: flex;
	align-items: center;
	gap: 1.5rem;
	padding: 1.5rem;
	background: #ffffff;
	border: 1px solid #e5e7eb;
	border-radius: 10px;
	transition: all 0.3s ease;
	margin-bottom: 1.5rem;

	&:hover {
		border-color: #10b981;
		box-shadow: 0 4px 12px rgba(16, 185, 129, 0.08);
	}

	.template-icon {
		width: 56px;
		height: 56px;
		background: linear-gradient(135deg, #10b981 0%, #059669 100%);
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;

		i {
			font-size: 1.75rem;
			color: white;
		}
	}

	.template-info {
		flex: 1;

		h4 {
			margin: 0 0 0.375rem 0;
			color: #1f2937;
			font-size: 1.0625rem;
			font-weight: 600;
		}

		p {
			margin: 0 0 0.75rem 0;
			color: #6b7280;
			font-size: 0.875rem;
		}
	}
}

.upload-area {
	text-align: center;
	padding: 3rem 2rem;
	border: 2px dashed #d1d5db;
	border-radius: 12px;
	background: #ffffff;
	transition: all 0.3s ease;
	cursor: pointer;

	&:hover, &.drag-over {
		border-color: #0A354E;
		background: #f5f7ff;

		.upload-icon {
			color: #0A354E;
			transform: translateY(-4px);
		}
	}

	.upload-icon {
		font-size: 3.5rem;
		color: #d1d5db;
		margin-bottom: 1rem;
		transition: all 0.3s ease;
	}

	h4 {
		color: #1f2937;
		margin-bottom: 0.5rem;
		font-size: 1.0625rem;
		font-weight: 600;
	}

	p {
		color: #6b7280;
		margin-bottom: 1.5rem;
		font-size: 0.9375rem;
	}

	small {
		display: block;
		margin-top: 0.75rem;
	}
}

.file-info-card {
	display: flex;
	align-items: center;
	gap: 1.25rem;
	padding: 1.25rem 1.5rem;
	background: #ecfdf5;
	border: 1px solid #a7f3d0;
	border-radius: 10px;
	margin-bottom: 1rem;

	.file-details {
		flex: 1;

		h4 {
			margin: 0 0 0.25rem 0;
			color: #065f46;
			font-size: 1rem;
			font-weight: 600;
		}

		p {
			margin: 0;
			color: #047857;
			font-size: 0.875rem;
		}
	}
}

.instructions-card {
	background: #fffbeb;
	border: 1px solid #fde68a;
	border-radius: 10px;
	padding: 1.5rem;

	.instruction-header {
		display: flex;
		align-items: center;
		color: #92400e;
		font-weight: 600;
		font-size: 1rem;
		margin-bottom: 1rem;

		i {
			font-size: 1.25rem;
			margin-right: 0.625rem;
		}
	}

	.instruction-list {
		list-style: none;
		padding: 0;
		margin: 0;

		li {
			padding: 0.625rem 0;
			padding-left: 1.75rem;
			position: relative;
			color: #78350f;
			font-size: 0.9375rem;
			line-height: 1.5;

			&:before {
				content: '✓';
				position: absolute;
				left: 0;
				color: #10b981;
				font-weight: bold;
				font-size: 1rem;
			}

			strong {
				color: #92400e;
				font-weight: 600;
			}
		}
	}
}

// Toast notifications personalizadas
:deep(.p-toast) {
	.p-toast-message {
		border-radius: 8px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	}

	.p-toast-message-success {
		background: #ecfdf5;
		border: 1px solid #a7f3d0;
		color: #065f46;

		.p-toast-message-icon {
			color: #10b981;
		}
	}

	.p-toast-message-error {
		background: #fef2f2;
		border: 1px solid #fecaca;
		color: #991b1b;

		.p-toast-message-icon {
			color: #ef4444;
		}
	}

	.p-toast-message-info {
		background: #eff6ff;
		border: 1px solid #bfdbfe;
		color: #1e40af;

		.p-toast-message-icon {
			color: #3b82f6;
		}
	}
}

// Inputs más limpios
:deep(.p-float-label) {
	margin-bottom: 0.25rem;

	input, .p-inputtext, .p-dropdown {
		border-color: #e5e7eb;
		
		&:hover {
			border-color: #d1d5db;
		}

		&:focus {
			border-color: #115780;
			box-shadow: 0 0 0 1px #0A354E;
		}
	}

	label {
		color: #6b7280;
		font-size: 0.9375rem;
	}
}

// Botones del footer
:deep(.p-dialog-footer) {
	background: #ffffff;
	border-top: 1px solid #e5e7eb;
	padding: 1.25rem 1.5rem;

	.p-button {
		font-weight: 500;
	}

	.p-button-primary {
		background: #667eea;
		border-color: #667eea;

		&:hover {
			background: #5568d3;
			border-color: #5568d3;
		}
	}
}

// Responsive
@media (max-width: 768px) {
	.section-header-detalles {
		flex-direction: column;
		gap: 0.75rem;
		align-items: flex-start;

		.p-button {
			width: 100%;
		}
	}

	.download-template-card {
		flex-direction: column;
		text-align: center;

		.template-info {
			text-align: center;
		}
	}

	.upload-area {
		padding: 2rem 1rem;
	}

	:deep(.detalles-table) {
		font-size: 0.8125rem;

		.p-datatable-thead > tr > th,
		.p-datatable-tbody > tr > td {
			padding: 0.75rem 0.5rem;
		}
	}

	.accordion-header-custom {
		flex-wrap: wrap;
		gap: 0.5rem;

		.text-sm {
			width: 100%;
			font-size: 0.8125rem;
		}
	}
}
.detalle-container-premium {
  padding: 0;
}

// Accordion Premium
:deep(.detalles-accordion-premium) {
  .p-accordion-header-link {
    padding: 0;
    border: none;
    background: transparent;
  }

  .p-accordion-tab {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	margin: 0.5rem 0;
  }

  .p-accordion-content {
    padding: 0;
    border: none;
  }
}

.accordion-header-premium {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
//   background: #ffffff;
  width: 100%;

  .header-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, #0d496b 0%, #0A354E 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.25rem;
    flex-shrink: 0;
  }

  .header-content {
    flex: 1;

    .detalle-title {
      font-size: 1.125rem;
      font-weight: 700;
      color: #1e293b;
      margin: 0 0 0.25rem 0;
    }

    .detalle-subtitle {
      font-size: 0.875rem;
      color: #64748b;
    }
  }

  .header-badge {
    flex-shrink: 0;
  }
}

// Tabs Premium
:deep(.detalle-tabs-premium) {
  .p-tabview-nav {
    background: #f8fafb;
    border: none;
    border-bottom: 2px solid #e2e8f0;
    padding: 0;
  }

  .p-tabview-nav-link {
    border: none;
    background: transparent;
    color: #64748b;
    font-weight: 600;
    font-size: 0.9375rem;
    padding: 1rem 1.5rem;

    &:hover {
      background: transparent;
      color: #1e293b;
    }
  }

  .p-highlight .p-tabview-nav-link {
    color: #1a5f7a;
    border-bottom: 3px solid #1a5f7a;
  }

  .p-tabview-panels {
    background: #ffffff;
  }
}

// Grid de Info Cards
.detalle-content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.info-card-premium {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  :deep(.p-card-title) {
    padding: 0.875rem 1rem;
    margin: 0;
    border-bottom: 1px solid #e2e8f0;
  }

  :deep(.p-card-content) {
    padding: 1rem;
  }

  &.producto :deep(.p-card-title) {
    background: #dbeafe;
  }

  &.peso :deep(.p-card-title) {
    background: #d1fae5;
  }

  &.unidades :deep(.p-card-title) {
    background: #fef3c7;
  }

  &.empaque :deep(.p-card-title) {
    background: #f3e8ff;
  }
}

.card-title-premium {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #1e293b;

  i {
    font-size: 1rem;
  }
}

.info-row {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.875rem;
  margin-bottom: 0.75rem;

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    color: #64748b;
    font-weight: 500;
  }
}

.metric-display {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;

  .metric-value {
    font-size: 2rem;
    font-weight: 700;
    color: #1e293b;
    line-height: 1;
  }

  .metric-unit {
    font-size: 0.875rem;
    color: #64748b;
    font-weight: 500;
  }
}

// Ruta Visual
.route-visual-premium {
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 1.5rem;
  background: #f8fafb;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  margin-bottom: 1.5rem;
}

.route-point {
  flex: 1;
  display: flex;
  gap: 1rem;

  &.origin .point-marker {
    background: linear-gradient(135deg, #10b981, #059669);
  }

  &.destination .point-marker {
    background: linear-gradient(135deg, #ef4444, #dc2626);
  }
}

.point-marker {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.point-content {
  flex: 1;
}

.point-label {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #64748b;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}

.point-name {
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.point-address {
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.5;
}

.route-line {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  color: #94a3b8;
}

// Timeline Horizontal
.timeline-horizontal-premium {
  position: relative;
  width: 100%;
  padding: 2rem 1rem;
  overflow: hidden;
}

.timeline-track {
  display: flex;
  align-items: stretch;
  gap: 2rem;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 1rem 1rem 1rem;
  flex-direction: row;
  flex-wrap: nowrap;
  scroll-behavior: smooth;
  
  // Scrollbar personalizado
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
    
    &:hover {
      background: #94a3b8;
    }
  }
}


.timeline-event {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-width: 100px;
  max-width: 280px;
  flex-shrink: 0;

  &.llegada .event-circle {
    background: linear-gradient(135deg, #2e7eff, #4b84ff);
  }

  &.carga .event-circle {
    background: linear-gradient(135deg, rgb(255, 210, 132), rgb(242, 174, 96));
  }

  &.descarga .event-circle {
    background: linear-gradient(135deg, #2e7299, #155e89);
  }

  &.aceptado .event-circle, &.exitoso .event-circle {
    background: linear-gradient(135deg, #36c094, #36c094);
  }

  &.rechazado .event-circle {
    background: linear-gradient(135deg, #ef4444, #dc2626);
  }

  &.pendiente .event-circle {
    background: linear-gradient(135deg, #f59e0b, #d97706);
  }
}

.timeline-track::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 2px;
  background: #e5e7eb;
  transform: translateY(-50%);
  z-index: 0;
}

.event-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.75rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-bottom: 1rem;
  z-index: 2;
}

.event-card-premium {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 1.25rem;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.event-title {
  font-size: 0.875rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.event-date {
  font-size: 0.8125rem;
  color: #64748b;
  margin-bottom: 1rem;
  padding: 0.375rem 0.75rem;
  background: #f8fafb;
  border-radius: 6px;
}

.event-actions-premium {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  :deep(.p-button) {
    font-size: 0.75rem;
    padding: 0.5rem 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    font-weight: 600;
  }
}

.event-connector {
  position: absolute;
  top: 32px;
  left: 100%;
  width: 2rem;
  height: 2px;
  background: linear-gradient(90deg, #cbd5e1, #e2e8f0);
}

.timeline-controls {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  pointer-events: none;
  padding: 0;

  :deep(.p-button) {
    pointer-events: all;
    background: white;
    border: 2px solid #e2e8f0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    &:hover {
      background: #f8fafb;
      border-color: #1a5f7a;
    }
  }
}

// Map Toggle
.map-toggle-premium {
  display: flex;
  justify-content: center;
  margin: 1.5rem 0;
}

.map-container-premium {
  margin-top: 1.5rem;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.leaflet-map {
  height: 500px;
  width: 100%;
}

// Empty State
.empty-state-premium {
  text-align: center;
  padding: 4rem 2rem;

  img {
    max-width: 200px;
    margin-bottom: 1.5rem;
    opacity: 0.6;
  }

  h4 {
    font-size: 1.125rem;
    font-weight: 600;
    color: #64748b;
  }
}

// Responsive
@media (max-width: 768px) {
  .route-visual-premium {
    flex-direction: column;
    gap: 1.5rem;
  }

  .route-line {
    transform: rotate(90deg);
  }

  .detalle-content-grid {
    grid-template-columns: 1fr;
  }

  .timeline-event {
    min-width: 240px;
  }

  .event-circle {
    width: 56px;
    height: 56px;
    font-size: 1.5rem;
  }
}
</style>
